module.exports = __webpack_public_path__ + "img/flowWisdomBlack.9b94a92a.png";